import './mail-comment-askForHelp-review-view.ajscss';

import { IEpticaDeprecatedService } from '@agent/core/channel-digit/mail/eptica/eptica-deprecated.service';
import { IContactDeprecatedService } from '@agent/core/contact/contact-deprecated.service';
import { IEpticaExctractEvent } from '@commons/history/history-mail/models/eptica-extract';
import { ng1Destroy } from '@commons/util/utilities/rx';
import { IComponentController, IComponentOptions } from 'angular';
import { combineLatest } from 'rxjs';

import templateUrl from './mail-comment-askForHelp-review-view.template.html';

class MailCommentAskForHelpReviewViewCtrl implements IComponentController {
  responseId: string;
  epticaEvents: { [type: string]: IEpticaExctractEvent[] } = {};
  commentsPanelOpened = false;

  constructor(
    private readonly epticaDeprecatedService: IEpticaDeprecatedService,
    private readonly contactDeprecatedService: IContactDeprecatedService
  ) {}

  $onInit(): void {
    this.contactDeprecatedService
      .getSelectedContact()
      .then(contact =>
        this.epticaDeprecatedService.loadRequest({
          requestId: contact.epticaRequestId || 0,
          responseId: this.responseId,
          lazy: true,
        })
      )
      .then(request => {
        const approvalEvts$ = request.retrieveApprovalEvents();
        const askForHelpEvts$ = request.retrieveAskForHelpEvents();
        combineLatest(approvalEvts$, askForHelpEvts$)
          .pipe(ng1Destroy(this))
          .subscribe(([approvalEvts, askForHelpEvts]) => {
            this.epticaEvents['APPROVAL'] = approvalEvts;
            this.epticaEvents['ASK_FOR_HELP'] = askForHelpEvts;

            if (approvalEvts.length > 0 || askForHelpEvts.length > 0) {
              $('#Area-WorkZone-Expand').removeClass('masked');
            } else {
              $('#Area-WorkZone-Expand').addClass('masked');
            }
          });
      });
  }
}

export class MailCommentAskForHelpReviewView implements IComponentOptions {
  templateUrl = templateUrl;
  bindings = {
    responseId: '<',
  };
  controller = ['epticaDeprecatedService', 'contactDeprecatedService', MailCommentAskForHelpReviewViewCtrl];
}

export default 'mailCommentAskForHelpReviewView';
